import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Layout from '@/views/Layout.vue'
import Orders from '@/views/user/Orders.vue'
import Codes from '@/views/user/Codes.vue'
import Info from '@/views/user/Info.vue'
import Activate from '@/views/user/Activate.vue'
import Create from '@/views/course/Create.vue'
import List from '@/views/course/List.vue'
import codeCreate from '@/views/code/Create.vue'
import codeList from '@/views/code/List.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  },
  {
    path: '/',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/user/info' },
      
      // 用户管理模块
      {
        path: 'user', // 相对路径
        component: { render: h => h('router-view') },
        children: [
          { path: 'info', name: 'Info', component: Info},
          { path: 'activate', name: 'activate', component: Activate},
          { path: 'orders', name: 'Orders', component: Orders},
          { path: 'codes', name: 'Codes', component: Codes}
        ]
      },
      
      // 课程管理模块
      {
        path: 'course',
        component: { render: h => h('router-view') },
        children: [
          { path: 'create', name: 'CourseCreate', component: Create },
          { path: 'list', name: 'CourseList', component: List }
        ]
      },

      // 激活码管理模块
      {
        path: 'code',
        component: { render: h => h('router-view') },
        children: [
          { path: 'create', name: 'CodeCreate', component: codeCreate },
          { path: 'list', name: 'CodeList', component: codeList },
        ]
      }
    ]
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('mzxltoken') // 假设 token 存在 localStorage 的 'admin-token' 字段

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 访问需要认证的页面
    if (!token) {
      // 无 token，跳转到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 可选：记录原路径，登录后跳回
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    // 访问游客页面（如登录页）
    if (token) {
      // 已登录用户不应再进登录页，跳转到首页
      next({ path: '/index' })
    } else {
      next()
    }
  } else {
    // 未设置 meta 的路由，按需处理（这里默认放行）
    next()
  }
})
export default router